const STORAGE_KEY = 'dvn_outreach_attribution';

/** LeadCRM affiliate_ref for partner-page → Calendly bookings (never use send_id here). */
export const PARTNER_PAGE_AFFILIATE_REF = 'PARTNER';

/**
 * Capture outreach UTM / send params from the current URL and persist (session).
 */
export function captureOutreachAttribution(search = window.location.search) {
  const params = new URLSearchParams(search);
  const sendId = params.get('send_id');
  const campaign = params.get('utm_campaign');
  const content = params.get('utm_content');
  const email = params.get('email');
  const name = params.get('name');
  const company = params.get('company');
  const source = params.get('utm_source');

  if (!sendId && !campaign && source !== 'email') {
    return readOutreachAttribution();
  }

  const attribution = {
    sendId: sendId ? Number(sendId) : null,
    campaignId: campaign && /^\d+$/.test(campaign) ? Number(campaign) : null,
    content: content || null,
    email: email || null,
    name: name || null,
    company: company || null,
    utmSource: source || null,
    utmMedium: params.get('utm_medium') || null,
    utmCampaign: campaign || null,
    capturedAt: Date.now(),
  };

  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(attribution));
  } catch {
    // ignore storage failures
  }
  return attribution;
}

export function readOutreachAttribution() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

/**
 * Calendly UTM payload for the partner-page embed.
 * utm_term is always PARTNER so LeadCRM labels the booking "Partner page booking".
 * send_id stays in first-party tracking (/campaigns/booked), not Calendly affiliate_ref.
 */
export function calendlyUtmFromAttribution(attribution) {
  return {
    utmSource: attribution?.utmSource || 'partner_page',
    utmMedium: attribution?.utmMedium || 'website',
    utmCampaign: attribution?.utmCampaign || 'partner_demo',
    utmContent: attribution?.content || 'demo',
    utmTerm: PARTNER_PAGE_AFFILIATE_REF,
  };
}

/**
 * POST first-party visit/click. Safe to call multiple times (server dedupes).
 */
export async function reportOutreachVisit(api, { type = 'partner_visit' } = {}) {
  const attribution = readOutreachAttribution();
  if (!attribution?.sendId && !attribution?.email && !attribution?.campaignId) {
    return { skipped: true };
  }
  try {
    const res = await api.post('/campaigns/visit', {
      sendId: attribution.sendId || undefined,
      campaignId: attribution.campaignId || undefined,
      email: attribution.email || undefined,
      type,
    });
    return res.data;
  } catch (err) {
    console.warn('Outreach visit report failed:', err?.message || err);
    return { error: true };
  }
}

export async function reportOutreachBooked(api, { email, name, scheduledAt, timezone } = {}) {
  const attribution = readOutreachAttribution();
  try {
    const res = await api.post('/campaigns/booked', {
      sendId: attribution?.sendId || undefined,
      campaignId: attribution?.campaignId || undefined,
      email: email || attribution?.email || undefined,
      name: name || attribution?.name || undefined,
      scheduledAt,
      timezone,
    });
    return res.data;
  } catch (err) {
    console.warn('Outreach booked report failed:', err?.message || err);
    return { error: true };
  }
}
